export default "__VITE_ASSET__DX6v3Moa__"